import React from 'react';
import Locations from '../../containers/Locations/Locations';

const LocationsPage = () => {
  return <Locations />;
};

export default LocationsPage;
